"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button"));

var _Legend = _interopRequireDefault(require("../Legend"));

var _helperFunctions = require("../../../../utils/helperFunctions");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _layout = _interopRequireDefault(require("./layout"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SliderContainer = /*#__PURE__*/function (_PureComponent) {
  _inherits(SliderContainer, _PureComponent);

  function SliderContainer(props) {
    var _this;

    _classCallCheck(this, SliderContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SliderContainer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      index: 1,
      slideArray: [],
      shouldAnimate: true,
      timeMove: 0,
      initialPosition: 0,
      finishPosition: 0,
      timeAnimation: _constants.FAST_ANIMATION
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", (0, _helperFunctions.throttle)(function (event) {
      _this.containerRef.current.addEventListener('mousemove', _this.handleMouseMove);

      window.addEventListener('mouseup', _this.handleEventUp);
      return _this.setState({
        initialPosition: event.clientX,
        shouldAnimate: false,
        timeMove: new Date().getTime()
      });
    }, _this.state.timeAnimation));

    _defineProperty(_assertThisInitialized(_this), "handleTouchDown", (0, _helperFunctions.throttle)(function (event) {
      _this.containerRef.current.addEventListener('touchmove', _this.handleTouchMove);

      window.addEventListener('touchend', _this.handleEventUp);
      return _this.setState({
        initialPosition: event.changedTouches[event.changedTouches.length - 1].clientX,
        shouldAnimate: false,
        timeMove: new Date().getTime()
      });
    }, _this.state.timeAnimation));

    _defineProperty(_assertThisInitialized(_this), "updateContainerWidth", function () {
      return _this.setState({
        containerWidth: _this.containerRef.current && _this.containerRef.current.clientWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNextSlide", function () {
      if (_this.imagesLength === _this.state.index) {
        _this.setState(function (prevState) {
          return {
            index: prevState.index + 1,
            shouldAnimate: true,
            timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
            disable: true
          };
        }, function () {
          return setTimeout(function () {
            return _this.setState(function (prevState) {
              return {
                index: 1,
                shouldAnimate: false,
                timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
                disable: false
              };
            });
          }, _this.state.timeAnimation);
        });
      } else _this.setState(function (prevState) {
        return {
          index: prevState.index + 1,
          shouldAnimate: true,
          timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
          disable: true
        };
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            disable: false
          });
        }, _this.state.timeAnimation);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePrevSlide", function () {
      if (_this.state.index === 1) {
        _this.setState(function (prevState) {
          return {
            index: 0,
            shouldAnimate: true,
            timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
            disable: true
          };
        }, function () {
          return setTimeout(function () {
            return _this.setState(function (prevState) {
              return {
                index: prevState.slideArray.length - 2,
                shouldAnimate: false,
                timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
                disable: false
              };
            });
          }, _this.state.timeAnimation);
        });
      } else _this.setState(function (prevState) {
        return {
          index: prevState.index - 1,
          shouldAnimate: true,
          timeAnimation: prevState.finishPosition === 0 ? _constants.SLOW_ANIMATION : prevState.timeAnimation,
          disable: true
        };
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            disable: false
          });
        }, _this.state.timeAnimation);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (event) {
      return _this.setState(function (prevState) {
        return {
          finishPosition: prevState.initialPosition - event.clientX
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function (event) {
      return _this.setState(function (prevState) {
        return {
          finishPosition: prevState.initialPosition - event.changedTouches[event.changedTouches.length - 1].clientX
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEventUp", function () {
      _this.containerRef.current.removeEventListener('mousemove', _this.handleMouseMove);

      _this.containerRef.current.removeEventListener('touchmove', _this.handleTouchMove);

      var containerWidth = _this.state.containerWidth;
      var time = new Date().getTime();
      var transitionTime = time - _this.state.timeMove;
      var fastAnimationRight = _this.state.finishPosition > 60;
      var fastAnimationLeft = _this.state.finishPosition < -60;
      var fastAnimation = transitionTime > 0 && transitionTime < _constants.MIN_TIME_MOVE && (fastAnimationRight || fastAnimationLeft);

      if (fastAnimation) {
        _this.setState({
          timeAnimation: _constants.FAST_ANIMATION
        });

        if (fastAnimationLeft) {
          _this.handlePrevSlide();
        } else if (fastAnimationRight) _this.handleNextSlide();
      }

      if (transitionTime !== 0 && -containerWidth / 3 >= _this.state.finishPosition && !fastAnimation) {
        _this.setState({
          timeAnimation: _constants.SLOW_ANIMATION
        });

        _this.handlePrevSlide();
      } else if (transitionTime !== 0 && containerWidth / 3 <= _this.state.finishPosition && !fastAnimation) {
        _this.setState({
          timeAnimation: _constants.SLOW_ANIMATION
        });

        _this.handleNextSlide();
      }

      return _this.setState({
        initialPosition: 0,
        finishPosition: 0,
        shouldAnimate: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLegend", function (item) {
      _this.setState({
        timeAnimation: 400,
        index: item
      });
    });

    _this.containerRef = _react["default"].createRef();
    _this.imagesLength = props.slides.length;
    return _this;
  }

  _createClass(SliderContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var arr = [this.props.slides[this.props.slides.length - 1]].concat(_toConsumableArray(this.props.slides), [this.props.slides[0]]);
      this.setState({
        slideArray: arr
      });
      this.containerRef.current.addEventListener('touchstart', this.handleTouchDown);
      this.containerRef.current.addEventListener('mousedown', this.handleMouseDown);
      this.updateContainerWidth();
      window.addEventListener('resize', this.updateContainerWidth);
      if (this.props.autoPlay) setInterval(function () {
        return _this2.handleNextSlide();
      }, this.props.autoPlayDelay);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          shouldAnimate = _this$state.shouldAnimate,
          slideArray = _this$state.slideArray,
          index = _this$state.index,
          timeAnimation = _this$state.timeAnimation,
          containerWidth = _this$state.containerWidth;
      var _this$props = this.props,
          withBorder = _this$props.withBorder,
          arrow = _this$props.arrow,
          legend = _this$props.legend,
          classes = _this$props.classes,
          slides = _this$props.slides,
          height = _this$props.height,
          activeEvents = _this$props.activeEvents,
          className = _this$props.className;
      var baseSlidePosition = (index - 1) * -containerWidth;
      var transitionSlide = !this.props.enableMove ? baseSlidePosition - this.state.finishPosition : baseSlidePosition;
      return _react["default"].createElement("div", {
        className: "".concat(_stylesModule["default"].generalContainer, " ").concat(className),
        style: {
          pointerEvents: "".concat(this.state.disable || !activeEvents ? 'none' : 'all'),
          height: height
        },
        draggable: "false"
      }, arrow && arrow.position === _constants.OUTSIDE && _react["default"].createElement("div", {
        className: _stylesModule["default"].arrowContainer
      }, _react["default"].createElement(_Button["default"], {
        ArrowCustom: arrow.arrowCustomLeft,
        callback: arrow.callbackLeft,
        onPress: this.handlePrevSlide,
        classes: classes,
        left: true
      })), _react["default"].createElement("div", {
        ref: this.containerRef,
        className: _stylesModule["default"].sliderContainer,
        draggable: "false"
      }, _react["default"].createElement(_layout["default"], {
        transitionSlide: transitionSlide,
        containerWidth: containerWidth,
        slideArray: slideArray,
        shouldAnimate: shouldAnimate,
        slides: slides,
        withBorder: withBorder,
        index: index,
        handleLegend: this.handleLegend,
        handlePrevSlide: this.handlePrevSlide,
        handleNextSlide: this.handleNextSlide,
        timeAnimation: timeAnimation,
        arrow: arrow,
        legend: legend,
        classes: classes
      })), legend && legend.position === _constants.OUTSIDE && _react["default"].createElement("div", {
        className: _stylesModule["default"].legendContainerOut
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].legend
      }, slides.map(function (_, item) {
        return _react["default"].createElement(_Legend["default"], {
          LegendCustom: legend.legendCustom,
          index: item,
          currentSlide: index === slideArray.length - 1 ? 0 : index === 0 ? 1 : index - 1,
          onClick: _this3.handleLegend,
          classes: classes,
          keyName: "legend-key-".concat(item)
        });
      }))), arrow && arrow.position === _constants.OUTSIDE && _react["default"].createElement("div", {
        className: _stylesModule["default"].arrowContainer
      }, _react["default"].createElement(_Button["default"], {
        ArrowCustom: arrow.arrowCustomRight,
        callback: arrow.callbackRight,
        onPress: this.handleNextSlide,
        classes: classes
      })));
    }
  }]);

  return SliderContainer;
}(_react.PureComponent);

SliderContainer.propTypes = {
  slides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    imgSrc: _propTypes.string
  })),
  arrow: (0, _propTypes.shape)({
    position: _propTypes.string,
    arrowCustomLeft: _propTypes.node,
    arrowCustomRight: _propTypes.node,
    callbackLeft: _propTypes.func,
    callbackRight: _propTypes.func
  }),
  legend: (0, _propTypes.shape)({
    position: _propTypes.string,
    legendCustom: _propTypes.node
  }),
  enableMove: _propTypes.bool,
  withBorder: _propTypes.number,
  autoPlay: _propTypes.bool,
  autoPlayDelay: _propTypes.number,
  activeEvents: _propTypes.bool,
  height: _propTypes.string,
  className: _propTypes.string,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types,

};
var _default = SliderContainer;
exports["default"] = _default;